"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTextarea = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const elements_1 = require("../../elements");
const lib_1 = require("../../lib");
const hooks_1 = require("../../hooks");
const EditableTextarea = (_a) => {
    var { value, onSave, onCancel, className, onChange, iconRight, highlight, onKeyDown, onKeyPress, placeholder } = _a, rest = (0, tslib_1.__rest)(_a, ["value", "onSave", "onCancel", "className", "onChange", "iconRight", "highlight", "onKeyDown", "onKeyPress", "placeholder"]);
    const [state, setState] = (0, react_1.useState)({ value, isEditing: false });
    const textArea = (0, react_1.useRef)(null);
    const { elementRef } = (0, hooks_1.useClickOnOutside)(() => {
        if (onCancel)
            onCancel();
        setState(state => (Object.assign(Object.assign({}, state), { isEditing: false, value })));
    });
    (0, react_1.useEffect)(() => {
        setState(state => (Object.assign(Object.assign({}, state), { value })));
    }, [value]);
    const handleChange = (0, react_1.useCallback)((value, e) => {
        setState(state => (Object.assign(Object.assign({}, state), { value })));
        if (onChange)
            onChange(value, e);
    }, [setState, onChange]);
    const handleCancel = (0, react_1.useCallback)(() => {
        if (onCancel)
            onCancel();
        setState(state => (Object.assign(Object.assign({}, state), { isEditing: false, value })));
    }, [onCancel, setState, value]);
    const handleSave = (0, react_1.useCallback)(() => {
        if (onSave)
            onSave(state.value);
        setState(state => (Object.assign(Object.assign({}, state), { isEditing: false })));
    }, [onSave, setState, state.value]);
    const handleClick = (0, react_1.useCallback)(() => {
        if (!state.isEditing)
            setState(state => (Object.assign(Object.assign({}, state), { isEditing: true })));
        textArea.current.focus();
    }, [state.isEditing, setState]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        if (e.keyCode === 27 || e.keyCode === 9) {
            setState(state => (Object.assign(Object.assign({}, state), { isEditing: false, value })));
        }
        if (onCancel)
            onCancel();
        if (onKeyDown)
            onKeyDown(e);
    }, [setState, value, onKeyDown, onCancel]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)('editable-textarea', (0, lib_1.use)(state.isEditing, '--is-editing'), (0, lib_1.use)(highlight, '--highlight'))), ref: elementRef }, { children: [(0, jsx_runtime_1.jsx)(elements_1.Textarea, Object.assign({ size: "2.5" }, rest, { className: "editable-textarea__input", value: state.value, onKeyDown: handleKeyDown, onChange: handleChange, onClick: handleClick, innerRef: textArea, readOnly: !state.isEditing, placeholder: !state.isEditing ? placeholder : undefined }), void 0), state.isEditing && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "editable-textarea__btns" }, { children: [(0, jsx_runtime_1.jsx)(elements_1.Button, Object.assign({ className: (0, lib_1.bem)('editable-textarea__btn', '--cancel'), onClick: handleCancel, secondary: true, size: "2.5", tabIndex: -1 }, { children: "Cancel" }), void 0), (0, jsx_runtime_1.jsx)(elements_1.Button, Object.assign({ className: (0, lib_1.bem)('editable-textarea__btn', '--save'), onClick: handleSave, success: true, size: "2.5", tabIndex: -1 }, { children: "Save Changes" }), void 0)] }), void 0)), !state.isEditing && iconRight && ((0, jsx_runtime_1.jsx)(elements_1.Icon, { name: iconRight, className: "editable-textarea__icon" }, void 0))] }), void 0));
    return null;
};
exports.EditableTextarea = EditableTextarea;
//# sourceMappingURL=EditableTextarea.js.map